var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgLinkedIn = function SvgLinkedIn(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 14 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.843 12.986h-2.74V4.383h2.74v8.602ZM2.454 3.207h.018c.955 0 1.55-.66 1.55-1.487C4.002.877 3.426.235 2.49.235S.94.877.94 1.72c0 .827.595 1.487 1.514 1.487ZM13.717 12.986h-2.74V8.383c0-1.157-.396-1.946-1.387-1.946-.757 0-1.207.532-1.405 1.046-.073.184-.091.44-.091.697v4.805H5.355s.036-7.796 0-8.602h2.74v1.22c.363-.587 1.013-1.423 2.467-1.423 1.803 0 3.155 1.229 3.155 3.873v4.933Z",
    fill: "#fff"
  })));
};

export { SvgLinkedIn as ReactComponent };
export default __webpack_public_path__ + "549b75e3a4cc4647f161df0aff765aa5.svg";